module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Cloud-download-66c2b01fb7dfd370fbe9588cd9229df0.svg";